import { maskitoParseNumber } from "@maskito/kit";

String.prototype.convertFrenchToEnglishDecimalNumber = function (this: string): number {
	return maskitoParseNumber(
		this,
		"," // decimal separator
	);
};

String.prototype.fullToDecimal = function (this: string): number {
	if (typeof this !== "string") {
		throw new Error("La valeur doit être une chaîne de caractères.");
	}

	return parseFloat(this) / 100;
};

String.prototype.replaceAllSpacesByASCII = function (this: string): string {
	if (typeof this !== "string") {
		throw new Error("La valeur doit être une chaîne de caractères.");
	}

	return this.replace(/ /g, "%20");
};

String.prototype.replaceAllSpacesByEmpty = function (this: string): string {
	if (typeof this !== "string") {
		throw new Error("La valeur doit être une chaîne de caractères.");
	}

	return this.replace(/ /g, "");
};

export {}; // this file needs to be a module
